import {
  Accordion as UiAccordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/src/components/ui/accordion";
import { Element } from "@craftjs/core";
import { Typography } from "@/src/components/Typography";

export function Accordion(props: any) {
  return (
    <UiAccordion {...props} type={props.accordionType} collapsible>
      {props.items.map((item: any, index: number) => (
        <AccordionItem key={item.value} value={item.value}>
          <AccordionTrigger className="text-dark-gray [&_path]:fill-[#009dd3]">
            {item.label}
          </AccordionTrigger>
          <AccordionContent>
            <Element is={Typography} id={`accordion-content-${index}`} canvas />
          </AccordionContent>
        </AccordionItem>
      ))}
    </UiAccordion>
  );
}
